import { Injectable } from '@angular/core';
import StarterKit from '@tiptap/starter-kit';
import Placeholder from '@tiptap/extension-placeholder';
import Table from '@tiptap/extension-table';
import TableRow from '@tiptap/extension-table-row';
import TableHeader from '@tiptap/extension-table-header';
import TableCell from '@tiptap/extension-table-cell';
import Underline from '@tiptap/extension-underline';
import { Extension, Mark } from '@tiptap/core';


@Injectable({
  providedIn: 'root'
})
export class RtfEditorService {

  constructor() { }

  getExtensions() {
    return [
      StarterKit,
      DisableNestedList,
      DisableListNesting,
      Underline,
      Table.configure({ resizable: true }),
      TableRow,
      TableHeader,
      TableCell,
      Placeholder.configure({
        placeholder: 'Generated note will appear here...',
      }),

      // Grounding / citation mark
      Mark.create({
        name: 'grounding',
        addAttributes() {
          return {
            'data-source-ids': {
              default: null,
              parseHTML: (el: HTMLElement) =>
                el.dataset['sourceIds'],
              renderHTML: (attrs) =>
                attrs['data-source-ids']
                  ? {
                    'data-source-ids': attrs['data-source-ids'],
                    class:
                      'grounding-source cursor-pointer hover:bg-yellow-500/20 underline',
                  }
                  : {},
            },
          };
        },
        parseHTML() {
          return [{ tag: 'span[data-source-ids]' }];
        },
        renderHTML({ HTMLAttributes }) {
          return ['span', HTMLAttributes, 0];
        },
      }),
    ];
  }

}


const DisableNestedList = Extension.create({
  name: 'disableNestedList',

  addKeyboardShortcuts() {
    return {
      Tab: () => true,        // prevent indent
      'Shift-Tab': () => true // prevent outdent nesting logic
    };
  },
});

const DisableListNesting = Extension.create({
  name: 'disableListNesting',

  addCommands() {
    return {
      sinkListItem:
        () =>
          () =>
            false, //  block nesting
    };
  },
});